import React from 'react';
import style from './style';
import { Grid } from '@mui/material';
import AssociatedTiers from '../../ContextDetail/AssociatedTiers';


const DeclarationTiersBlock = ({
  thirdPartyId,
  associatedTP,
  context,
}) => {
  const { classes } = style();

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <AssociatedTiers
            context={context}
            associatedTP={associatedTP}
            startPoint={thirdPartyId}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default DeclarationTiersBlock;
